<template>
  <div class="sky-step-view-env-collect">
    <div class="env-collect-group">
      <div class="env-collect-group-title">
        <div class="collect-group-title-icon"></div>
        <div class="collect-group-title-value">场景</div>
        <div class="collect-group-title-tip">
          本栏目展示客户采集数据与场景的绑定关系，也可取消与重新绑定，客户环境采集可点击右侧工具进行下载（支持Windows7/Windows10/Windows11）
        </div>
        <div class="collect-group-title-tool sk-link--normal el-icon-download" @click="downloadCollectTool()">
          环境采集工具下载
        </div>
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div v-html="downToolTip" slot="content"></div>
          <i class="el-icon-question collect-group-title-tool sk-link--normal"></i>
        </el-tooltip>
      </div>
      <div class="collect-group-content">
        <div class="env-info-env-rl-scene">
          <!-- <div class="env-info-env-rl-scene-title">环境信息与场景绑定</div> -->
          <div class="env-info-env-rl-scene-content env-rl-scene-content">
            <div v-for="(sceneItem, sceneIndex) in scenes" :key="sceneIndex" class="env-rl-scene-item">
              <el-card class="env-rl-scene-item-content">
                <div slot="header">
                  <!-- <span>{{ sceneItem.sceneName }}</span> -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="sceneItem.sceneName"
                    placement="top-start"
                    v-if="isShowTooltip(sceneItem.sceneName)"
                  >
                    <span style="white-space: nowrap;">{{ sceneItem.sceneName }}</span>
                  </el-tooltip>
                  <span v-else style="white-space: nowrap;">{{ sceneItem.sceneName }}</span>
                  <!-- <el-button class="handel-btn" type="text" @click="importReport(sceneItem, sceneIndex)"
                    >采集导入</el-button
                  >
                  <el-button class="handel-btn" type="text" @click="cleanCollectReport(sceneItem, sceneIndex)"
                    >清除导入</el-button
                  > -->
                </div>
                <div
                  class="text item"
                  v-if="sceneItem.collectReportDTOList && sceneItem.collectReportDTOList.length > 0"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`${sceneItem.collectReportDTOList.map(item => item.customerPosition).join(', ')} `"
                    placement="right-start"
                    v-if="isShowTooltip(sceneItem.collectReportDTOList.map(item => item.customerPosition).join(', '))"
                  >
                    <div>已绑定:{{ sceneItem.collectReportDTOList.map(item => item.customerPosition).join(', ') }}</div>
                  </el-tooltip>
                  <div v-else>
                    已绑定:{{ sceneItem.collectReportDTOList.map(item => item.customerPosition).join(', ') }}
                  </div>
                </div>
                <div class="text item sk-link--normal" @click="importReport(sceneItem, sceneIndex)">
                  环境信息采集录入
                </div>
                <div class="elnv-rl-scene-coll wsp-display-flex">
                  <div class="elnv-rl-scene-coll-item ">
                    <div class="coll-item-title">终端：</div>
                    <div class="coll-item-value">{{ sceneItem.terminalCont }}</div>
                  </div>
                  <div class="elnv-rl-scene-coll-item">
                    <div class="coll-item-title">外设：</div>
                    <div class="coll-item-value">{{ sceneItem.peripheralCont }}</div>
                  </div>
                  <div class="elnv-rl-scene-coll-item">
                    <div class="coll-item-title">软件：</div>
                    <div class="coll-item-value">{{ sceneItem.softwareCont }}</div>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="env-collect-group">
      <div class="env-collect-group-title">
        <div class="collect-group-title-icon"></div>
        <div class="collect-group-title-value">场景采集信息确认</div>
        <div class="collect-group-title-tip">
          本栏目展示从客户环境的采集外设、软件、终端等详细信息
        </div>
      </div>
      <div class="collect-group-content">
        <div class="env-collect-item env-info-env-rl-scene-client">
          <div class="env-collect-item-title">终端：</div>
          <div class="env-collect-item-content">
            <el-table ref="scene-rl-client" :data="collectEnvData.sceneRelationTerminal" :show-header="true">
              <el-table-column :label="$t('pocMng.client.version')" prop="model" show-overflow-tooltip />
              <el-table-column :label="$t('pocMng.client.cpu')" show-overflow-tooltip prop="cpu" />
              <el-table-column label="CPU核数" show-overflow-tooltip prop="cpuCore" />
              <el-table-column label="厂商" show-overflow-tooltip prop="manufacturer" />
              <el-table-column :label="$t('pocMng.client.memory')" show-overflow-tooltip prop="memory" />
              <el-table-column :label="$t('pocMng.client.disk')" show-overflow-tooltip prop="diskSize" />
              <el-table-column :label="$t('pocMng.client.diskNum')" show-overflow-tooltip prop="diskCount" />
              <el-table-column :label="$t('pocMng.client.gpu')" show-overflow-tooltip prop="gpuModel" />
              <el-table-column :label="$t('pocMng.client.enableUEFI')" show-overflow-tooltip prop="enableUEFI">
                <template slot-scope="scope">
                  <span v-if="scope.row.SUPPORTsUEFI">是</span>
                  <span v-else>否</span>
                </template></el-table-column
              >
              <el-table-column label="来源场景" show-overflow-tooltip prop="sceneName" />
            </el-table>
          </div>
        </div>
        <div class="env-collect-item">
          <div class="env-collect-item-title">外设：</div>
          <div class="env-collect-item-content">
            <el-table ref="scene-rl-terminal" :data="collectEnvData.sceneRelationPeripheral" :show-header="true">
              <el-table-column :label="$t('pocMng.peripheral.name')" prop="name" show-overflow-tooltip />
              <el-table-column
                :label="$t('pocMng.peripheral.manufacturer')"
                prop="manufacturer"
                show-overflow-tooltip
              />
              <el-table-column :label="$t('pocMng.peripheral.type')" prop="typeCN" show-overflow-tooltip />
              <el-table-column
                :label="$t('pocMng.peripheral.interfaceType')"
                prop="interfaceType"
                show-overflow-tooltip
              />
              <el-table-column label="来源场景" show-overflow-tooltip prop="sceneName" />
            </el-table>
          </div>
        </div>
        <div class="env-collect-item">
          <div class="env-collect-item-title">软件：</div>
          <div class="env-collect-item-content">
            <el-table ref="scene-rl-soft" :data="collectEnvData.sceneRelationSoft" :show-header="true">
              <el-table-column :label="$t('pocMng.soft.softwareName')" prop="softwareName" show-overflow-tooltip />
              <el-table-column
                :label="$t('pocMng.soft.softwareVersion')"
                prop="softwareVersion"
                show-overflow-tooltip
              />
              <el-table-column :label="$t('pocMng.soft.publisher')" prop="publisher" show-overflow-tooltip />
              <el-table-column :label="$t('pocMng.soft.archType')" prop="archType" show-overflow-tooltip />
              <el-table-column :label="$t('pocMng.soft.purpose')" prop="purpose" show-overflow-tooltip />
              <el-table-column :label="$t('pocMng.soft.requirement')" prop="requirement" show-overflow-tooltip />
              <el-table-column label="来源场景" show-overflow-tooltip prop="sceneName" />
            </el-table>
          </div>
        </div>
        <div class="env-collect-item env-rl-scene-radio-group">
          <div class="env-collect-item-title">操作系统：</div>
          <div class="env-collect-item-content radio-group-value">
            <el-checkbox-group v-model="collectEnvData.sceneRelationSystem">
              <el-checkbox
                disabled="disabled"
                v-for="(sysItem, sysIndex) in collectEnvData.sceneRelationSystem"
                :label="sysItem"
                :key="sysIndex"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="group-buttom"></div> -->

    <el-drawer
      ref="drawer"
      :key="drawerKey"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="handleCloseDrawer"
      direction="rtl"
    >
      <div
        class="env-collect-group"
        style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 70px;"
      >
        <div class="env-collect-group-title">
          <div class="collect-group-title-icon"></div>
          <div class="collect-group-title-value">客户环境采集报告选择</div>
        </div>
      </div>
      <el-row class="wsp-padding-top-18">
        <el-button style="margin-left: 13px;margin-bottom: 10px;" type="primary" @click="uploadReport"
          >导入报告（采集工具）</el-button
        >
        <el-button style="margin-left: 5px;margin-bottom: 10px;" type="primary" @click="ReportCreate"
          >手工添加客户环境信息</el-button
        >
        <el-button style="margin-left: 5px;margin-bottom: 10px;" type="primary" @click="importCollectTemplate"
          >按模板导入客户环境信息</el-button
        >
      </el-row>
      <report-table :params="changeScene" @chagneSceneRelation="changeSceneRel" @edit="edit"></report-table>
    </el-drawer>

    <el-dialog title="提示" :visible.sync="unBindReportVisible" width="30%" :show-close="false">
      <div>
        <div class="wsp-padding-tb-12 backgroud-color-f5f2f2 wsp-margin-tb-24 " style="padding-left: 10px !important">
          确定不绑定客户环境采集信息就提交吗？
        </div>
        <el-input type="textarea" :rows="5" placeholder="请填写不绑定采集报告原因" v-model="unbindReason"> </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="unBindReportVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUnbindReason" :disabled="!unbindReason">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Card,
  Row,
  Button,
  Input,
  CheckboxGroup,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  Drawer,
  Dialog
} from 'element-ui'

import { extend } from 'sk-ui/lib/utils/util.js'

import ReportTable from './reportTable'

import { getDetail } from '@/api/project'
import { sceneBindDetail, collectDetail, updateSceneRealtionEnv } from '@/api/scene'
import importCollectTemplate from '@/store/modules/pocMng/metaData/importCollectTemplate'
import reportCreateForm from '@/store/modules/pocMng/metaData/reportCreateForm'
import uploadCollectReport from '@/store/modules/pocMng/metaData/uploadCollectReport'
import { getCollectTool, isDeepEqual } from '@/utils/pageUtils'
export default {
  name: 'SkyStepViewEnvCollet',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Card.name]: Card,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    [Dialog.name]: Dialog,
    [Row.name]: Row,
    ReportTable
  },
  props: {
    projectId: {
      type: String,
      default: null
    },
    projectState: {
      type: String,
      default: null
    }
  },
  created() {},
  mounted() {
    this.$emit('openChangeDialog', { projectId: this.projectId })
    this.$emit('showBtns', {
      preStep: false,
      nextStep: false,
      saveStep: false,
      enableTabChange: true
    })
    this.getInitDat()
  },
  data: function() {
    return {
      dialogVisible: false,
      drawerKey: 0,
      changeScene: {},
      unbindReason: null,
      changeSceneIndex: null,
      scenes: [],
      unBindReportVisible: false,
      collectEnvData: {
        sceneRelationTerminal: [],
        sceneRelationSoft: [],
        sceneRelationPeripheral: [],
        sceneRelationSystem: []
      },
      repportData: {},
      reqReportId: [],
      tempData: {},
      maxLength: 20,
      customer: null,
      downToolTip: `1、下载工具放到客户PC解压，点击WSPTool应用程序运行，输入基础信息后，点击开始采集<br>2、查看报告：查看PDF格式的报告<您可以通过1.导入环境采集工具输出的采集报告解决或点击场景中的“环境信息采集录入”链接手动录入解决。>3、导出报告：离线环境下需要导出zip格式的包，然后手动上传到平台<必须采集软件信息,您可以通过以下方式解决：>4、上传报告：联网环境下点击后可自动上传到平台`,
      professionalWinningProject: false
    }
  },
  methods: {
    getData() {
      var saveParams = this.getTempData()
      var equal = isDeepEqual(this.tempData, saveParams)
      if (equal) {
        return {
          dataChange: false
        }
      } else {
        this.tempData = saveParams
        return {
          dataChange: true,
          busDATA: saveParams
        }
      }
    },
    getTempData() {
      var saveParams = {
        sceneCollect: []
      }
      for (const iterator of this.scenes) {
        saveParams.sceneCollect.push({
          sceneId: iterator.sceneId,
          collectReportDTOList: iterator.collectReportDTOList,
          sceneName: iterator.sceneName,
          reportCustomerPosition: iterator.reportCustomerPosition,
          bindCollectSoft: iterator.bindCollectSoft
        })
      }
      return saveParams
    },
    submitUnbindReason() {
      this.$emit('handelToAutoNext')
    },
    async saveStep() {
      var saveParams = {
        projectId: this.projectId,
        flowStep: 'PROJECT_ENV',
        unbindReason: this.unbindReason,
        sceneCollectBindDTOList: []
      }
      var list = []
      let bindReportTooMore = false
      for (const iterator of this.scenes) {
        var reportIdArr = []
        if (iterator.collectReportDTOList) {
          reportIdArr = iterator.collectReportDTOList.map(obj => obj.id)
          if (reportIdArr.length > 5) {
            bindReportTooMore = true
          }
          iterator.collectReportDTOList.forEach(obj => list.push(obj.id))
        }
        saveParams.sceneCollectBindDTOList.push({
          sceneId: iterator.sceneId,
          reportIdArr: reportIdArr
        })
      }
      if (bindReportTooMore) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return false
      }

      var result = false
      await updateSceneRealtionEnv(saveParams)
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            result = true
          }
        })
        .catch(e => {
          result = false
        })
      return result
    },
    async gotoNextPreVliate() {
      if (this.checkSceneNeedBindSoft()) {
        this.$store.dispatch('OpenNotification', {
          message: `场景：${this.checkSceneNeedBindSoft()} \n必须采集软件信息,您可以：\n1.导入环境采集工具输出的采集报告。\n2.点击场景中的“环境信息采集录入”链接手动录入。`,
          duration: 15000,
          type: 'error'
        })
        return false
      }
      // 校验是否绑定了参数
      var bindReport = true
      for (const iterator of this.scenes) {
        if (iterator.collectReportDTOList && iterator.collectReportDTOList.length == 0) {
          bindReport = false
          break
        }
      }
      if (!bindReport && !this.unbindReason) {
        this.unBindReportVisible = true
        // TODO 弹窗填写信息
        return false
      } else {
        return true
      }
    },
    checkSceneNeedBindSoft() {
      if (this.scenes?.length) {
        var tipName = ''
        for (const data of this.scenes) {
          if ((data.bindCollectSoft || this.professionalWinningProject) && data.softwareCont <= 0) {
            tipName = tipName + '【' + data.sceneName + '】'
          }
        }
        if (tipName !== '') {
          return tipName
        }
      }
      return false
    },
    async gotoNextStep() {
      var saveParams = {
        projectId: this.projectId,
        flowStep: 'PROJECT_ENV',
        noReportReason: this.unbindReason,
        sceneCollectBindDTOList: []
      }

      var list = []
      let bindReportTooMore = false

      for (const iterator of this.scenes) {
        var reportIdArr = []
        if (iterator.collectReportDTOList) {
          reportIdArr = iterator.collectReportDTOList.map(obj => obj.id)
          if (reportIdArr.length > 5) {
            bindReportTooMore = true
          }
          iterator.collectReportDTOList.forEach(obj => list.push(obj.id))
        }
        saveParams.sceneCollectBindDTOList.push({
          sceneId: iterator.sceneId,
          reportIdArr: reportIdArr
        })
      }
      if (bindReportTooMore) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return false
      }
      var result = true
      await updateSceneRealtionEnv(saveParams).catch(e => {
        result = false
      })
      return result
    },
    gotoPreStep() {
      return true
    },
    getInitDat() {
      this.reqReportId = []
      sceneBindDetail({ id: this.projectId }).then(res => {
        this.scenes = res.data.content.sceneCollect
        this.getRelationCollectInfo()
        this.tempData = this.getTempData()
      })
      getDetail({ id: this.projectId }).then(res => {
        const content = res.data.content
        this.customer = content.customer
        this.professionalWinningProject = content.professionalWinningProject
      })
    },
    getRelationCollectInfo() {
      this.reqReportIdArr = []
      var sceneCollectBindList = []
      this.scenes.forEach(item => {
        item.terminalCont = 0
        item.softwareCont = 0
        item.peripheralCont = 0
        if (item.collectReportDTOList) {
          sceneCollectBindList.push({
            sceneId: item.sceneId,
            reportIdArr: item.collectReportDTOList.map(obj => obj.id)
          })
        }
      })
      var reqPrams = {
        sceneCollectBindList: sceneCollectBindList
      }

      collectDetail(reqPrams).then(res => {
        this.collectEnvData.sceneRelationSystem = res.data.content.operationSystem

        this.collectEnvData.sceneRelationTerminal = res.data.content.terminal
        this.collectEnvData.sceneRelationSoft = res.data.content.software
        this.collectEnvData.sceneRelationPeripheral = res.data.content.peripheral

        var sceneReportCountMap = res.data.content.sceneReportCountMap
        for (let index = 0; index < this.scenes.length; index++) {
          var countInfo = sceneReportCountMap[this.scenes[index].sceneId]
          this.$set(this.scenes[index], 'terminalCont', countInfo.terminalCount)
          this.$set(this.scenes[index], 'softwareCont', countInfo.softwareCount)
          this.$set(this.scenes[index], 'peripheralCont', countInfo.peripheralCount)
        }
      })
    },
    importReport(sceneItem, index) {
      this.dialogVisible = true
      this.drawerKey++
      this.changeScene = sceneItem
      this.changeScene.projectId = this.projectId
      this.changeSceneIndex = index
    },
    downloadCollectTool() {
      getCollectTool()
    },
    changeSceneRel(params) {
      this.changeScene = params
      this.scenes[this.changeSceneIndex] = this.changeScene
      this.getRelationCollectInfo()
      this.handleCloseDrawer()

      var saveParams = this.getTempData()
      var equal = isDeepEqual(this.tempData, saveParams)
      if (!equal) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: true,
          saveStep: false,
          enableTabChange: false
        })
      }
    },
    handleCloseDrawer() {
      this.getRelationCollectInfo()
      this.dialogVisible = false
    },
    cleanCollectReport(sceneItem, index) {
      this.$set(this.scenes[index], 'reportId', null)
      this.$set(this.scenes[index], 'reportCustomerPosition', null)
      this.getRelationCollectInfo()

      var saveParams = this.getTempData()
      var equal = isDeepEqual(this.tempData, saveParams)
      if (!equal) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: true,
          saveStep: false,
          enableTabChange: false
        })
      }
      // 清除导入
    },
    ReportCreate({ commit }, params) {
      const props = {
        'view.content[$id=customer].$el': { disabled: true },
        'view.content[$id=customer].$default': this.customer,
        'view.showOkBtn': false,
        'view.showCancelBtn': false,
        toolbar: {
          items: [
            {
              slot: 'refresh-rigtht',
              label: 'confirm',
              props: {
                type: 'primary',
                disabled: false
              },
              action: 'AfterReportCreate'
            },
            {
              slot: 'refresh-rigtht',
              label: 'cancel',
              action: 'ReturnPage'
            }
          ]
        },
        extraParams: {
          collectView: this
        }
      }
      this.$store.dispatch('OpenFullDialog', {
        metaData: reportCreateForm,
        props
      })
    },
    edit(id) {
      const props = {
        'view.content[$id=customer].$el': { disabled: true },
        'view.content[$id=customer].$default': this.customer,
        'view.content[$id=terminal].$el': { isEdit: true },
        params: {
          id: id
        },
        needFetchFillInfo: true,
        title: '编辑客户终端环境信息'
      }
      this.$store.dispatch('OpenFullDialog', {
        metaData: reportCreateForm,
        props
      })
    },
    uploadReport({ commit }, params) {
      const uploadCollectReportCopy = extend(true, {}, uploadCollectReport)
      var props = {
        params: {}
      }
      this.$store.dispatch('OpenFullDialog', { metaData: uploadCollectReportCopy, props, clone: false })
    },
    importCollectTemplate({ commit }, params) {
      const importCollectTemplateCopy = extend(true, {}, importCollectTemplate)
      var props = {
        params: {},
        templateDownload: this.projectId
      }
      this.$store.dispatch('OpenFullDialog', { metaData: importCollectTemplateCopy, props, clone: false })
    },
    isShowTooltip(content) {
      return content.length > this.maxLength
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-view-env-collect) {
  height: 100%;
  overflow-y: scroll;
  .env-collect-group {
    .env-collect-group-title {
      margin: 12px 0;
      width: 100%;
      display: flex;
      .collect-group-title-icon {
        width: 6px;
        line-height: 28px;
        background-color: #0052d9;
      }
      .collect-group-title-value {
        font-size: 18px;
        line-height: 28px;
        padding-left: 12px;
      }
      .collect-group-title-tip {
        line-height: 28px;
        padding-left: 12px;
        color: gray;
      }
      .collect-group-title-tool {
        line-height: 28px;
        padding-left: 12px;
      }
    }
  }
  .group-buttom {
    height: 128px;
  }

  .env-collect-item {
    padding: 0 6px;
    display: flex;
    margin-bottom: 12px;
    .env-collect-item-title {
      text-align: right;
      padding: 12px 0;
      font-weight: 600;
      width: 6%;
    }
    .env-collect-item-content {
      width: 90%;
      .env-collect-item-title {
        text-align: right;
        font-weight: 600;
        padding: 0 9 !important;
        width: 6%;
      }
    }
  }
  .env-rl-scene-radio-group {
    line-height: 28px;
    .radio-group-value {
      line-height: 48px;
      padding-left: 12px;
    }
  }
  .env-info-env-rl-scene {
    padding: 6px 6px;
    .env-rl-scene-content {
      display: flex;
      flex-wrap: wrap;
      .env-rl-scene-item {
        width: 20%;
        padding: 6px;
        .env-rl-scene-item-content {
          border: 1px solid #ccc;
          border-radius: 6px;
          height: 145px;
          .item-content-header {
            width: 225px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 260px; /* 设置div的宽度 */
            white-space: nowrap; /* 确保内容在一行显示 */
            overflow: hidden; /* 超出部分隐藏 */
            text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
          }
          .el-card__body {
            padding: 12px 18px;
          }
          .elnv-rl-scene-coll-item {
            padding: 12px 0;
            width: 33%;
            display: flex;
            .coll-item-title {
              width: 60%;
              text-align: right;
            }
          }
        }
        .handel-btn {
          float: right;
          padding: 0;
        }
      }
    }
  }
}
</style>
